import {constants} from '@newsela/angelou';
import {css} from 'emotion';

const suggestionWrapper = css`
  position: relative;
  margin: 0;
  padding: 0;
`;

const suggestionList = css`
  position: absolute;
  top: 10px;
  left: 0;
  margin: 0;
  width: 79%;
  padding: 20px 16px 16px 16px;
  background-color: ${constants.colors.ui.white['700']};
  z-index: 20;
  box-shadow: 4px 5px 10px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  border-radius: 4px;
`;

const globalNavSuggestionsContainer = css`
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  background-color: ${constants.colors.ui.white['700']};
  padding: 0;
`;

const globalNavList = css`
  border-radius: 4px;
  padding: 17px 16px 16px 16px;
`;

export default {
  globalNavList,
  globalNavSuggestionsContainer,
  suggestionWrapper,
  suggestionList,
};
